import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from '@core/notifications/notification.service';
import { AuthSessionStore } from './auth-session.store';
import { LOGIN_PATH } from './auth-paths';

/**
 * Shared by the HTTP interceptor, the GraphQL error link and the token refresher so all of them
 * end a session identically: clear the session, tell the admin once, open /login.
 * Must not depend on Apollo (the Apollo error link injects it).
 */
@Injectable({ providedIn: 'root' })
export class SessionExpiredHandler {
  private readonly session = inject(AuthSessionStore);
  private readonly router = inject(Router);
  private readonly notifications = inject(NotificationService);

  handle(): void {
    const hadSession = this.session.hasSession();
    this.session.clear();
    if (this.router.url.startsWith(LOGIN_PATH)) {
      return;
    }
    if (hadSession) {
      this.notifications.warning('Your session has expired. Please sign in again.');
    }
    void this.router.navigateByUrl(LOGIN_PATH);
  }
}
